// frontend/src/api/partner.api.js
import apiClient from './client.js';

export const getPartners = async (params = {}) => {
  const response = await apiClient.get('/partners', { params });
  return response.data.data;
};

export const getPartner = async (id) => {
  const response = await apiClient.get(`/partners/${id}`);
  return response.data.data;
};

export const createPartner = async (data) => {
  const response = await apiClient.post('/partners', data);
  return response.data.data;
};

export const updatePartner = async (id, data) => {
  const response = await apiClient.put(`/partners/${id}`, data);
  return response.data.data;
};

export const restorePartner = async (id) => {
  const response = await apiClient.post(`/partners/${id}/restore`);
  return response.data.data;
};

export const revokePartner = async (id) => {
  const response = await apiClient.post(`/partners/${id}/revoke`);
  return response.data.data;
};

export const deletePartner = async (id) => {
  const response = await apiClient.delete(`/partners/${id}`);
  return response.data.data;
};

export const uploadPartnerDocument = async (partnerId, formData) => {
  const response = await apiClient.post(`/partners/${partnerId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
};

export const getPartnerDocumentUrl = async (partnerId, docId) => {
  const response = await apiClient.get(`/partners/${partnerId}/documents/${docId}`);
  return response.data.data;
};
